module.exports = __webpack_public_path__ + "img/sdc2018_8.0ff48694.png";